import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Paper,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  LinearProgress,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { MEESHO } from "app/routes/constant";

const MeeshoReport = () => {
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();

  // Static dataset derived from Order-CSV.csv
  const orders = [
    {
      orderedOn: "Aug 02, 2025",
      shipmentId: "1085fab4-768e-442a-9ff1-ddc236a83b31",
      orderItemId: "335097043180988100",
      orderId: "OD335097043180988100",
      hsnCode: "621142",
      orderState: "Delivered",
      orderType: "NON_FBF",
      fsn: "AZTHEGH8TWMVMHMJ",
      sku: "FK-2PC-ARYA-CRMSN-M-VTCN-0725",
      product: "SSTUDIO Top Palazzos Co-ords Set Crimson M FKARYA",
      invoiceNo: "FAVNM02600000009",
      cgst: "NA",
      igst: 5,
      sgst: "NA",
      invoiceDate: "08/02/25",
      invoiceAmount: 777,
      sellingPricePerItem: 640,
      shippingCharges: 0,
      quantity: 1,
      priceIncFkmp: 777,
      buyerName: "Sanjay Thakur",
      shipToName: "Sanjay Thakur",
      addressLine1: "House no 146/2 Golbag Sunder Nagar",
      addressLine2: "Near Mahamaya Temple Stairs",
      city: "Mandi District",
      state: "Himachal Pradesh",
      pinCode: "175018",
      dispatchAfterDate: "Aug 02, 2025 11:47:15",
      dispatchByDate: "Aug 04, 2025 12:00:00",
      trackingId: "FMPP3229299958",
      packageLengthCm: 38,
      packageBreadthCm: 32,
      packageHeightCm: 4,
      packageWeightKg: 0.5,
      readyToMake: "NO",
    },
    {
      orderedOn: "Jul 31, 2025",
      shipmentId: "8bee33b2-8923-43f2-8924-50e1e9624df6",
      orderItemId: "335082788797374100",
      orderId: "OD335082788797374100",
      hsnCode: "621142",
      orderState: "Delivered",
      orderType: "NON_FBF",
      fsn: "SWDHEDJFDHFNBU2Q",
      sku: "FK-3PC-BROCKTON-PLVNDR-M-CAMBRC-0725",
      product: "SSTUDIO Floral Print Kurta, Salwar & Dupatta Set M FKBROCKTON",
      invoiceNo: "FAVNM02600000003",
      cgst: "NA",
      igst: 5,
      sgst: "NA",
      invoiceDate: "08/01/25",
      invoiceAmount: 836,
      sellingPricePerItem: 691,
      shippingCharges: 0,
      quantity: 1,
      priceIncFkmp: 836,
      buyerName: "Archi ",
      shipToName: "Archi ",
      addressLine1: "Badiya beer near dremworld school",
      addressLine2: "Bus stand",
      city: "Sultanpur",
      state: "Uttar Pradesh",
      pinCode: "228001",
      dispatchAfterDate: "Jul 31, 2025 20:11:25",
      dispatchByDate: "Aug 04, 2025 12:00:00",
      trackingId: "FMPC5054595950",
      packageLengthCm: 38,
      packageBreadthCm: 32,
      packageHeightCm: 4,
      packageWeightKg: 0.5,
      readyToMake: "NO",
    },
    {
      orderedOn: "Aug 01, 2025",
      shipmentId: "a40bac8a-059f-4f19-96b1-355a5c8a081e",
      orderItemId: "435092651246624100",
      orderId: "OD435092651246624100",
      hsnCode: "621142",
      orderState: "Delivered",
      orderType: "NON_FBF",
      fsn: "SWDHED3UBRUCCZ3Z",
      sku: "FK-3PC-SAIYARA-GN-L-CAMBRC-0725",
      product:
        "Savreesachi Studio Printed, Embroidered Kurta, Salwar & Dupatta Set L FKSAIYARA",
      invoiceNo: "FAVNM02600000007",
      cgst: "NA",
      igst: 5,
      sgst: "NA",
      invoiceDate: "08/02/25",
      invoiceAmount: 949,
      sellingPricePerItem: 704,
      shippingCharges: 0,
      quantity: 1,
      priceIncFkmp: 949,
      buyerName: "Subodh Kumar Mandal",
      shipToName: "Subodh Kumar Mandal",
      addressLine1: "3",
      addressLine2:
        "sonwa dangal behind polytechnic college , railway station road,near panni tanki,dumka,jharkhand",
      city: "Dumka",
      state: "Jharkhand",
      pinCode: "814101",
      dispatchAfterDate: "Aug 01, 2025 23:40:42",
      dispatchByDate: "Aug 05, 2025 12:00:00",
      trackingId: "FMPP3229033875",
      packageLengthCm: 38,
      packageBreadthCm: 32,
      packageHeightCm: 4,
      packageWeightKg: 0.5,
      readyToMake: "NO",
    },
    {
      orderedOn: "Aug 01, 2025",
      shipmentId: "70894a39-39a0-43f7-8270-e9a82fac69ac",
      orderItemId: "335088170425508100",
      orderId: "OD335088170425508100",
      hsnCode: "621142",
      orderState: "Return Requested",
      orderType: "NON_FBF",
      fsn: "AZTHEGH8GV4EVHXB",
      sku: "FK-2PC-ARYA-DBL-XXL-VTCN-0725",
      product: "SSTUDIO Top Palazzos Co-ords Set Dark Blue XXL FKARYA",
      invoiceNo: "FAVNM02600000004",
      cgst: "NA",
      igst: 5,
      sgst: "NA",
      invoiceDate: "08/01/25",
      invoiceAmount: 777,
      sellingPricePerItem: 666,
      shippingCharges: 0,
      quantity: 1,
      priceIncFkmp: 777,
      buyerName: "Kshama Chaturvedi",
      shipToName: "Kshama Chaturvedi",
      addressLine1:
        "House no.- 06, sharda vihar. City center.near royal Enfield showroom",
      addressLine2:
        "Jiwaji University Captain Roop Singh Sports Hostel, Sharda Vihar, Mahalgaon",
      city: "Gwalior",
      state: "Madhya Pradesh",
      pinCode: "474011",
      dispatchAfterDate: "Aug 01, 2025 11:08:45",
      dispatchByDate: "Aug 02, 2025 12:00:00",
      trackingId: "FMPP3225962375",
      packageLengthCm: 38,
      packageBreadthCm: 32,
      packageHeightCm: 4,
      packageWeightKg: 0.5,
      readyToMake: "NO",
    },
    {
      orderedOn: "Aug 01, 2025",
      shipmentId: "2ce9df0e-971f-4da6-8913-bcee959d3ecf",
      orderItemId: "335088170425508101",
      orderId: "OD335088170425508100",
      hsnCode: "621142",
      orderState: "Return Requested",
      orderType: "NON_FBF",
      fsn: "AZTHEGH8TNYVGHJU",
      sku: "FK-2PC-ARYA-RGLD-XXL-VTCN-0725",
      product: "SSTUDIO Top Palazzos Co-ords Set Rose Gold XXL FKARYA",
      invoiceNo: "FAVNM02600000005",
      cgst: "NA",
      igst: 5,
      sgst: "NA",
      invoiceDate: "08/01/25",
      invoiceAmount: 777,
      sellingPricePerItem: 666,
      shippingCharges: 0,
      quantity: 1,
      priceIncFkmp: 777,
      buyerName: "Kshama Chaturvedi",
      shipToName: "Kshama Chaturvedi",
      addressLine1:
        "House no.- 06, sharda vihar. City center.near royal Enfield showroom",
      addressLine2:
        "Jiwaji University Captain Roop Singh Sports Hostel, Sharda Vihar, Mahalgaon",
      city: "Gwalior",
      state: "Madhya Pradesh",
      pinCode: "474011",
      dispatchAfterDate: "Aug 01, 2025 11:08:45",
      dispatchByDate: "Aug 02, 2025 12:00:00",
      trackingId: "FMPP3225960374",
      packageLengthCm: 38,
      packageBreadthCm: 32,
      packageHeightCm: 4,
      packageWeightKg: 0.5,
      readyToMake: "NO",
    },
    {
      orderedOn: "Aug 02, 2025",
      shipmentId: "4fffe337-9f93-42f4-ad39-2868e6153cf1",
      orderItemId: "335096867981818100",
      orderId: "OD335096867981818100",
      hsnCode: "621142",
      orderState: "Delivered",
      orderType: "NON_FBF",
      fsn: "AZTHEGH8DD6EAGVD",
      sku: "FK-2PC-ARYA-LCYN-XXL-VTCN-0725",
      product: "SSTUDIO Top Palazzos Co-ords Set Azure Green XXL FKARYA",
      invoiceNo: "FAVNM02600000008",
      cgst: "NA",
      igst: 5,
      sgst: "NA",
      invoiceDate: "08/02/25",
      invoiceAmount: 777,
      sellingPricePerItem: 666,
      shippingCharges: 0,
      quantity: 1,
      priceIncFkmp: 777,
      buyerName: "Z Khan",
      shipToName: "Z Khan",
      addressLine1: "476/371 TG hostel road",
      addressLine2: "Iradat Nagar, Hasanganj",
      city: "Lucknow Division",
      state: "Uttar Pradesh",
      pinCode: "226020",
      dispatchAfterDate: "Aug 02, 2025 11:18:42",
      dispatchByDate: "Aug 04, 2025 12:00:00",
      trackingId: "FMPP3229254117",
      packageLengthCm: 38,
      packageBreadthCm: 32,
      packageHeightCm: 4,
      packageWeightKg: 0.5,
      readyToMake: "NO",
    },
    {
      orderedOn: "Aug 01, 2025",
      shipmentId: "c0c3177a-ce15-4017-8f5d-5e7dd773f2f8",
      orderItemId: "335088655438621100",
      orderId: "OD335088655438621100",
      hsnCode: "621142",
      orderState: "Delivered",
      orderType: "NON_FBF",
      fsn: "AZTHEGH84KP2THFX",
      sku: "FK-2PC-ARYA-LCYN-M-VTCN-0725",
      product: "SSTUDIO Top Palazzos Co-ords Set Azure Green M FKARYA",
      invoiceNo: "FAVNM02600000006",
      cgst: "NA",
      igst: 5,
      sgst: "NA",
      invoiceDate: "08/01/25",
      invoiceAmount: 777,
      sellingPricePerItem: 666,
      shippingCharges: 0,
      quantity: 1,
      priceIncFkmp: 777,
      buyerName: "Raksha ",
      shipToName: "Raksha ",
      addressLine1: "Sabulal ward garhakota",
      addressLine2: "Sabulal ward near police station garhakota",
      city: "Sagar District",
      state: "Madhya Pradesh",
      pinCode: "470232",
      dispatchAfterDate: "Aug 01, 2025 12:29:24",
      dispatchByDate: "Aug 04, 2025 12:00:00",
      trackingId: "FMPC5055512900",
      packageLengthCm: 38,
      packageBreadthCm: 32,
      packageHeightCm: 4,
      packageWeightKg: 0.5,
      readyToMake: "NO",
    },
  ];

  // Computed summaries
  const totalOrders = orders.length;
  const totalRevenue = orders.reduce(
    (sum, order) => sum + (order.invoiceAmount || 0),
    0
  );
  const deliveredOrders = orders.filter((o) => o.orderState === "Delivered");
  const returnRequestedOrders = orders.filter(
    (o) => o.orderState === "Return Requested"
  );
  const deliveredCount = deliveredOrders.length;
  const returnRequestedCount = returnRequestedOrders.length;
  const deliveryRate = totalOrders ? (deliveredCount / totalOrders) * 100 : 0;
  const returnRate = totalOrders
    ? (returnRequestedCount / totalOrders) * 100
    : 0;
  const avgPackageWeight = orders.length
    ? orders.reduce((s, o) => s + (o.packageWeightKg || 0), 0) / orders.length
    : 0;

  const revenueByStateMap = orders.reduce((acc, order) => {
    const key = order.state || "Unknown";
    if (!acc[key]) {
      acc[key] = { state: key, revenue: 0, orders: 0 };
    }
    acc[key].revenue += order.invoiceAmount || 0;
    acc[key].orders += 1;
    return acc;
  }, {});
  const revenueByState = Object.values(revenueByStateMap).sort(
    (a, b) => b.revenue - a.revenue
  );

  const formatCurrency = (value) => `₹${(value || 0).toLocaleString("en-IN")}`;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: "bold" }}>
          Reports & Analytics
        </Typography>
        <Button
          variant="contained"
          size="small"
          sx={{ width: "100px" }}
          startIcon={<Icon icon="ep:back" width="24" height="24" />}
          onClick={() => navigate(MEESHO)}
        >
          Back
        </Button>
      </div>

      {/* Report Tabs */}
      <Card>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            {/* <Tab
              label="Sales Summary"
              icon={<Icon icon="material-symbols:trending-up" />}
              iconPosition="start"
            /> */}
            <Tab
              label="Performance Metrics"
              icon={<Icon icon="material-symbols:speed" />}
              iconPosition="start"
            />
            <Tab
              label="State Analysis"
              icon={<Icon icon="material-symbols:map" />}
              iconPosition="start"
            />
          </Tabs>
        </Box>

        <CardContent>
          {/* Sales Summary Tab */}
          {/* {tabValue === 0 && (
            <Box>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                Orders & Revenue Overview
              </Typography>

              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper
                    sx={{
                      p: 2,
                      textAlign: "center",
                      background:
                        "linear-gradient(135deg, #4caf5015, #4caf5005)",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: "bold", color: "#4caf50" }}
                    >
                      {formatCurrency(totalRevenue)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Revenue
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper
                    sx={{
                      p: 2,
                      textAlign: "center",
                      background:
                        "linear-gradient(135deg, #2196f315, #2196f305)",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: "bold", color: "#2196f3" }}
                    >
                      {totalOrders}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Orders
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper
                    sx={{
                      p: 2,
                      textAlign: "center",
                      background:
                        "linear-gradient(135deg, #ff980015, #ff980005)",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: "bold", color: "#ff9800" }}
                    >
                      {formatCurrency(averageOrderValue)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Average Order Value
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper
                    sx={{
                      p: 2,
                      textAlign: "center",
                      background:
                        "linear-gradient(135deg, #9c27b015, #9c27b005)",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: "bold", color: "#9c27b0" }}
                    >
                      {(deliveryRate || 0).toFixed(1)}%
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Delivery Rate
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Ordered On</TableCell>
                      <TableCell>Order ID</TableCell>
                      <TableCell>Product</TableCell>
                      <TableCell>City</TableCell>
                      <TableCell>State</TableCell>
                      <TableCell>Qty</TableCell>
                      <TableCell>Invoice Amount</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders.map((order, index) => (
                      <TableRow key={index} hover>
                        <TableCell>{order.orderedOn}</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          {order.orderId}
                        </TableCell>
                        <TableCell>{order.product}</TableCell>
                        <TableCell>{order.city}</TableCell>
                        <TableCell>{order.state}</TableCell>
                        <TableCell>{order.quantity}</TableCell>
                        <TableCell
                          sx={{ fontWeight: "bold", color: "#4caf50" }}
                        >
                          {formatCurrency(order.invoiceAmount)}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={order.orderState}
                            color={
                              order.orderState === "Delivered"
                                ? "success"
                                : order.orderState === "Return Requested"
                                ? "warning"
                                : "default"
                            }
                            size="small"
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )} */}

          {/* Performance Metrics Tab */}
          {tabValue === 0 && (
            <Box>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                Key Performance Indicators
              </Typography>

              {[
                {
                  metric: "Delivery Rate",
                  current: deliveryRate,
                  target: 95,
                },
                {
                  metric: "Return Rate",
                  current: returnRate,
                  target: 2.5,
                },
                {
                  metric: "Avg Package Weight (kg)",
                  current: avgPackageWeight,
                  target: 0.5,
                },
              ].map((metric, index) => (
                <Paper key={index} sx={{ p: 3, mb: 2 }}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        {metric.metric}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Current:{" "}
                        {metric.metric.includes("Rate")
                          ? `${metric.current.toFixed(1)}%`
                          : metric.current.toFixed(2)}{" "}
                        | Target:{" "}
                        {metric.metric.includes("Rate")
                          ? `${metric.target}%`
                          : metric.target}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LinearProgress
                        variant="determinate"
                        value={Math.min(
                          100,
                          metric.metric.includes("Return")
                            ? (metric.target /
                                Math.max(metric.current, 0.001)) *
                                100
                            : (metric.current / metric.target) * 100
                        )}
                        sx={{ height: 10, borderRadius: 5 }}
                        color={
                          metric.metric.includes("Return")
                            ? metric.current <= metric.target
                              ? "success"
                              : "warning"
                            : metric.current >= metric.target
                            ? "success"
                            : "warning"
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          color: (
                            metric.metric.includes("Return")
                              ? metric.current <= metric.target
                              : metric.current >= metric.target
                          )
                            ? "#4caf50"
                            : "#f44336",
                        }}
                      >
                        {(metric.metric.includes("Return")
                          ? metric.target - metric.current
                          : metric.current - metric.target
                        ).toFixed(1)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </Box>
          )}

          {/* State Analysis Tab */}
          {tabValue === 1 && (
            <Box>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                Revenue by State
              </Typography>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>State</TableCell>
                      <TableCell>Revenue</TableCell>
                      <TableCell>Orders</TableCell>
                      <TableCell>Share</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {revenueByState.map((row, index) => (
                      <TableRow key={index} hover>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          {row.state}
                        </TableCell>
                        <TableCell
                          sx={{ fontWeight: "bold", color: "#4caf50" }}
                        >
                          {formatCurrency(row.revenue)}
                        </TableCell>
                        <TableCell>{row.orders}</TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <LinearProgress
                              variant="determinate"
                              value={
                                totalRevenue
                                  ? (row.revenue / totalRevenue) * 100
                                  : 0
                              }
                              sx={{ width: 100, mr: 1 }}
                            />
                            <Typography variant="caption">
                              {totalRevenue
                                ? ((row.revenue / totalRevenue) * 100).toFixed(
                                    1
                                  )
                                : 0}
                              %
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default MeeshoReport;
